import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

const ADMIN_ACCOUNT = 'admin@antsnest.co.kr';

export default function ProtectedAdmin({ children }) {
  const [status, setStatus] = useState('loading'); // loading | ok | denied

  useEffect(() => {
    let mounted = true;
    fetch('/api/check-session', { credentials: 'include' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (!mounted) return;
        const account = data?.user?.user_account || data?.user?.userId;
        if (account === ADMIN_ACCOUNT) setStatus('ok');
        else setStatus('denied');
      })
      .catch(() => mounted && setStatus('denied'));
    return () => {
      mounted = false;
    };
  }, []);

  if (status === 'loading') {
    return (
      <div className="admin-gate-loading">
        <div className="admin-gate-spinner" />
      </div>
    );
  }
  if (status === 'denied') {
    return <Navigate to="/Login" replace />;
  }
  return children;
}
